if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }
   
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {

            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(response);
            //dispatch custom event, when item added to cart
            document.body.dispatchEvent(new CustomEvent('product-added-to-cart', { 'detail': response }));
            if (response.product_type == 'synbiotic' || response.product_type == 'dailybacs' || response.product_type == 'dietbacs' || response.product_type == 'dermabacs' || response.product_type == 'bundle') {
              document.body.dispatchEvent(new CustomEvent('synbiotic-added-to-cart', { 'detail': response }));
            } else {
              document.body.dispatchEvent(new CustomEvent('addon-added-to-cart'));
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// let mov_gift_exists = locales_variables.free_gift_from.length == 0 ? false : true;
// document.body.addEventListener("addon-added-to-cart", () => {
//   if (location.href.indexOf('cart') > -1 && !mov_gift_exists) {
//     location.reload();
//   }
// });

// Welcome Jar
document.body.addEventListener("synbiotic-added-to-cart", e => {
  if (e.detail.properties._welcome_kit != undefined) {
    let items = [];
    let welcome_jars = e.detail.properties._welcome_kit.split(',');

    let multiplier = 1;
    for (let i = 0; i < welcome_jars.length; i++) { 
      if (welcome_jars[i].length > 0) {
        if (welcome_jars[i] == welcome_jars[i + 1]) {
          console_log('next element is the same - qty before', multiplier)
          multiplier += 1;
          console_log('next element is the same - qty after', multiplier)
          continue;
        }
        console_log(i, multiplier);
        items.push({
          "id": welcome_jars[i],
          "quantity": multiplier,
          "properties": {
            "_boughtWith": e.detail.handle,
            "_key": e.detail.key,
            "_multiplier": multiplier
          }
        });
      }
    }

    // welcome_jars.forEach(jar => {
    //   if (jar.length > 0) {
    //     items.push({
    //       "id": jar,
    //       "quantity": 1,
    //       "properties": {
    //         "_boughtWith": e.detail.handle,
    //         "_key": e.detail.key
    //       }
    //     });
    //   }
    // });
    console_log(items);
  
    let formData = {
      "items": items
    }

    ajaxAddToCart(formData);
  }
});


const ajaxAddToCart = (addData) => {
  let cart_link = document.getElementById('cart-notification-button');
  fetch('/cart/add.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    method: 'POST'
  }).then(function (response) {
    return response.json();
  }).then(function (json) {
    console_log(json);
  }).catch(function (err) {
    console.error(err);
  })
    .finally(() => cart_link && cart_link.classList.remove('disabled'))
}


const getCart = async () => {
  return await fetch(`/cart.json`)
    .then(response => {
      return response.json();
    })
    .then(data => {
      return data;
    })
    .catch(err => {
      console.error(err);
    });
}